import AlertasTiposForm from "./AlertasTiposForm";
export default AlertasTiposForm;
